/*
 *	@created: 05.04.2017, 12:07:25
 * 	@author: André Müller <am@ccdm.de>
 *
 */

(function ($) {
	$(document).ready(function () {
		setContrastCookie();
	});

	function setContrastCookie() {
		//console.log($.cookie('t3zcontrast'));
		if ($.cookie('t3zcontrast') == 'true') {
			$('#contrastview').prop('checked', true);
		}
		$('label[for="contrastview"]').click(function (event) {
			if ($.cookie('t3zcontrast') == 'true') {
				$.cookie('t3zcontrast', 'false', {expires: 1, path: '/'});
			} else {
				$.cookie('t3zcontrast', 'true', {expires: 1, path: '/'});
			}
			//console.log($.cookie('t3zcontrast'));
		});
	}
})(jQuery);



//////////////////
// WEBPACK FOOTER
// /Users/wobble/Sites/ksg/www/typo3conf/ext/t3zeroseven/Resources/Public/Scripts/T3Zero/setContrastCookie.js
// module id = c8nw
// module chunks = 1